import { WindowHelperService } from '@anecdotes/utils';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef, inject, DestroyRef } from '@angular/core';
import { Subject, debounceTime, filter, map, takeUntil } from 'rxjs';
import { VirtualScrollContextService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-virtual-scroll-item',
  templateUrl: './virtual-scroll-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VirtualScrollItemComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly scrollingDetacher = new Subject<void>();
  private isScrolling = false;
  private get itemId(): string {
    return this.elementRef.nativeElement.id;
  }

  @HostBinding('class')
  private classes = 'block item-wrapper';

  @Input()
  itemTemplate: TemplateRef<any>;

  @Input()
  itemContext: any;

  @Input()
  item: any;

  @Output()
  sizeChange = new EventEmitter<void>();

  constructor(
    private virtualScrollContext: VirtualScrollContextService,
    private cd: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>,
    private windowHelper: WindowHelperService
  ) {}

  ngOnInit(): void {
    this.windowHelper.observeResize(this.elementRef.nativeElement)
      .pipe(
        debounceTime(500),
        map((risizeEntries) => risizeEntries[0].contentRect),
        filter((contentRect) => this.virtualScrollContext.getSize(this.itemId)?.height !== contentRect.height),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((contentRect) => {
        this.sizeChange.emit();
        this.virtualScrollContext.setSize({
          itemId: this.itemId,
          width: contentRect.width,
          height: contentRect.height,
        });
      });

    if (this.virtualScrollContext.isEnabled()) {
      this.isScrolling = this.virtualScrollContext.isScrollingSync();

      this.virtualScrollContext
        .isScrolling()
        .pipe(takeUntil(this.scrollingDetacher), takeUntilDestroyed(this.destroyRef))
        .subscribe((isScrolling) => {
          this.isScrolling = isScrolling;

          if (isScrolling === false) {
            this.scrollingDetacher.next();
          }

          this.cd.detectChanges();
        });
    }
  }

  getFinalContext(): any {
    return { ...this.itemContext, isScrolling: this.isScrolling, size: this.virtualScrollContext.getSize(this.itemId) };
  }
}
